import {
  booleanSchema,
  Contact,
  ContactSchema,
  emailSchema,
  objectIdSchema,
  optionalStringSchema,
  paginationWithSearchSchema,
} from '@hero/schema';
import { API } from '..';
import { z } from 'zod';

const baseSchema = ContactSchema.model
  .pick({ name: true, phone: true, _id: true })
  .extend({ email: optionalStringSchema(emailSchema) });
// * get all api
export const contactGetAllSchemaAPI = paginationWithSearchSchema.extend({
  customerId: objectIdSchema
    .optional()
    .describe(
      'Filter to contacts belonging to a specific Client (`Client._id`). Omit to list contacts across all clients.',
    ),
  isOwnContact: booleanSchema
    .optional()
    .describe(
      "When true, narrow to the caller's own contacts (not tied to a third-party Client).",
    ),
});
export type ContactGetAllAPI = API<z.infer<typeof contactGetAllSchemaAPI>, Contact[]>;

//* create api
export const contactCreateAPISchema = baseSchema.omit({ _id: true }).extend({
  customerId: objectIdSchema
    .optional()
    .describe(
      "Client (`Client._id`) this contact belongs to. Omit to create as the caller's own contact.",
    ),
});
export type ContactCreateAPI = API<z.infer<typeof contactCreateAPISchema>, Contact>;

//* update api
export const contactUpdateAPISchema = contactCreateAPISchema
  .pick({ name: true })
  .extend({ _id: baseSchema.shape._id.describe('`Contact._id` to update.') });

export type ContactUpdateAPI = API<z.infer<typeof contactUpdateAPISchema>, Contact>;

// * get one api
export const contactGetOneSchemaAPI = z.object({
  _id: baseSchema.shape._id.describe('`Contact._id` (24-char Mongo ObjectId).'),
});
export type ContactGetOneAPI = API<z.infer<typeof contactGetOneSchemaAPI>, Contact>;

// * delete api
export const contactDeleteAPISchema = z.object({
  _id: baseSchema.shape._id.describe('`Contact._id` to delete.'),
});
export type ContactDeleteAPI = API<z.infer<typeof contactDeleteAPISchema>, Contact>;

//* admin get all contacts with optional filters
export const contactGetAllAdminAPISchema = paginationWithSearchSchema.extend({
  /** Optional: filter by organization ID */
  orgId: objectIdSchema.optional(),
  /** if customer id is provided, then it will return all contacts that belongs to the third party customer. */
  customerId: objectIdSchema.optional(),
  /** filter by own contact only */
  isOwnContact: booleanSchema.optional(),
});
export type ContactGetAllAdminAPI = API<z.infer<typeof contactGetAllAdminAPISchema>, Contact[]>;

//* admin create api
export const contactCreateAdminAPISchema = contactCreateAPISchema.extend({
  /** this is the organization id. This will be used by Super Admin only. */
  orgId: objectIdSchema,
});
export type ContactCreateAdminAPI = API<z.infer<typeof contactCreateAdminAPISchema>, Contact>;
